import { useMemo } from 'react';
import { useGetCategoriesQuery } from '../api';

export function useDefaultSubcategoryId() {
  const { data } = useGetCategoriesQuery({});
  
  return useMemo(() => {
    if (!data?.data) return null;
    
    const categories = data.data;
    
    for (const category of categories) {
      if (category.subcategories && category.subcategories.length > 0) {
        const found = category.subcategories.find(sub => {
          const name = sub.name.toLowerCase();
          return name === 'miscellaneous' || name === 'other';
        });
        if (found) {
          return found.id;
        }
      }
    }
    
    return null;
  }, [data]);
}

